import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button } from 'antd';
import { logIn, setUsername } from '../../store/routines';
import InputValidationMessage from '../../components/InputMessageContainers/InputValidationMessage';
import {
  PRIVACY_POLICY_URL,
  TERMS_URL,
} from '../../common/constants/CommonConstants';
import { formatUserName } from '../../common/util/EmailUtils';
import { cognitoLoginErrorMessageFormatter } from '../../common/util/authUtils';

function ActivateAccountForm() {
  const dispatch = useDispatch();

  const [errorVisible, setErrorVisible] = useState(false);
  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const isError = useSelector((state) => state.auth.isError);

  const onLogin = (values) => {
    const { username, password, remember } = values;
    const formattedUserName = formatUserName(username);
    dispatch(setUsername({ username: formattedUserName }));
    dispatch(logIn({ username: formattedUserName, password, remember }));
  };

  useEffect(() => {
    if (errorMessage) {
      setErrorVisible(true);
    }
  }, [errorMessage]);

  const onFormChange = (changedValues) => {
    if (changedValues) {
      setErrorVisible(false);
    }
  };

  return (
    <>
      <div className="login-input-wrapper">
        <div className="title smaller">Activate your account</div>
        <div className="subtitle">
          <h4>Welcome to Velaris!</h4>
          Please enter your username and temporary password.
        </div>
        <Form
          name="login_step_1"
          className="login-form"
          onValuesChange={onFormChange}
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onLogin}
        >
          {isError && errorVisible && (
            <div className="login-error-bar">
              <i className="icon core-icon core-alert-outlined" />{' '}
              {cognitoLoginErrorMessageFormatter(errorMessage)}
            </div>
          )}
          <Form.Item
            name="username"
            label="Username"
            className="login-field"
            rules={[
              {
                required: true,
                message: (
                  <InputValidationMessage message="Please enter your username" />
                ),
              },
            ]}
          >
            <Input className="login-field" placeholder="Email Address" />
          </Form.Item>
          <Form.Item
            label="Temporary Password"
            name="password"
            className="login-field password"
            rules={[
              {
                required: true,
                message: (
                  <InputValidationMessage message="Please enter your password" />
                ),
              },
            ]}
          >
            <Input.Password
              className="login-field"
              placeholder="Temporary Password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button loginbtn"
            >
              Continue
            </Button>
            <div className="">
              By signing up, I agree to the Velaris{' '}
              <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">
                Privacy Policy
              </a>{' '}
              and{' '}
              <a href={TERMS_URL} target="_blank" rel="noreferrer">
                Terms of Service
              </a>
              .
            </div>
          </Form.Item>
        </Form>
      </div>
      <div className="floating-login-footer">
        {/* <a href="#app" className="request-new-pw">
          Request new password
        </a> */}
      </div>
    </>
  );
}

export default ActivateAccountForm;
